import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

import { makeStyles } from '@mui/styles';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardActionArea from '@mui/material/CardActionArea';
import StyledTooltip from './styled/tooltip';

const useStyles = makeStyles(theme => ({
    card: {
        maxWidth: 345,
    },
    policyCardBackground: {
        background: theme.palette.background.paper,
        paddingLeft: '10px',
        border: '0px solid',
    },
    policyCardContainer: {
        display: 'flex',
        background: theme.palette.background.paper,
    },
    cardTitle: {
        fontSize: '1.25rem',
    },
    actionContainer: {
        flexGrow: 1,
        height: '135px',
        '& .MuiCardActionArea-root': {
            height: '100%',
            display: 'flex',
            verticalAlign: 'baseline',
            alignItems: 'baseline',
            justifyContent: 'flex-start',
        }
    },
}));

const MC2Managed = {
    suricata_rules: true,
    zeek_indicators: true,
};

const PolicyCard = (props) => {
    const MC2CHECK = process.env.BRICATA_APPLIANCE_TYPE === 'mc2';
    const classes = useStyles();
    const navigate = useNavigate();
    const [disable] = useState(!MC2CHECK && MC2Managed[props.type] && props.source === 'mc2');

    const handleSelect = (route) => {
        navigate(route);
    };

    return (
        <Card aria-label={props.title + ' policy card'} className={classes.card} style={{ opacity: props.pending ? 0.2 : 1 }}>
            <StyledTooltip
                title="Unable to view or edit Suricata Rule policies assigned to a CMC from an MC2"
                disableFocusListener={!disable}
                disableHoverListener={!disable}
                disableTouchListener={!disable}
            >
                <Box className={classes.policyCardBackground} style={{ background: props.color ? props.color : '' }}>
                    <Box className={classes.policyCardContainer}>
                        <Box className={classes.actionContainer}>
                            <CardActionArea
                                aria-label="select policy"
                                onClick={() => { handleSelect(props.route) }}
                                disabled={disable || props.pending || props.busy}
                            >
                                <CardHeader
                                    titleTypographyProps={{
                                        className: classes.cardTitle
                                    }}
                                    title={props.title}
                                    subheader={props.subtitle || ''}
                                />
                                {/* <Box display="flex" justifyContent="flex-end" width="100%">
                                    <Button variant="contained" color="primary" aria-label="select policy" onClick={() => {handleSelect(props.route)}}><EditIcon /> Edit</Button>
                                </Box> */}
                            </CardActionArea>
                        </Box>
                        <Box>
                            {props.action || null}
                        </Box>
                    </Box>
                </Box>
            </StyledTooltip>
        </Card>
    );
};

PolicyCard.propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.node,
    description: PropTypes.string,
    action: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    route: PropTypes.string.isRequired,
    color: PropTypes.string,
    type: PropTypes.string.isRequired,
    source: PropTypes.string,
    pending: PropTypes.bool, // this policy isn't done getting created
    busy: PropTypes.bool, // policy service is busy
};

export default PolicyCard;
